import { Injectable, ChangeDetectorRef, ChangeDetectionStrategy, Component } from '@angular/core';
import 'rxjs/Rx';
import 'rxjs/add/operator/takeUntil';

// Import de nm-socle-application
import { BootstrapService, BootstrapStep } from '../../services/bootstrap.service';
import { CustomerConfig } from '../../shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';


@Component({
    selector: 'splashscreen',
    templateUrl: './splashscreen.component.html',
    styleUrls: ['./splashscreen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

@Injectable()
export class SplashscreenComponent extends AbstractComponent {
    public footer:string;
    public customerConfig:CustomerConfig;

    public currentStep: BootstrapStep = {
        id: null,
        status: null,
        message: null
    };

    public actions = [
        { id: 'DOWNLOAD', 'icon': 'fa fa-download', 'status': 'waiting', 'message': 'splashscreen.labels.download' },
        { id: 'LOCAL_CONFIG', 'icon': 'fa fa-gear', 'status': 'waiting', 'message': 'splashscreen.labels.local-config' },
        { id: 'SECURITY', 'icon': 'fa fa-shield', 'status': 'waiting', 'message': 'splashscreen.labels.security-config' },
        { id: 'STYLE', 'icon': 'fa fa-paint-brush', 'status': 'waiting', 'message': 'splashscreen.labels.style' },
        { id: 'LOGIN', 'icon': 'fa fa-lock', 'status': 'waiting', 'message': 'splashscreen.labels.auth' },
        { id: 'REMOTE_CONFIG', 'icon': 'fa fa-link', 'status': 'waiting', 'message': 'splashscreen.labels.remote-config' },
        { id: 'DEFINITION', 'icon': 'fa fa-map', 'status': 'waiting', 'message': 'splashscreen.labels.app-config' }
    ];

    /**
     * @constructor
     * @description
     * Vue permmettant de suivre la progression des étapes d'initialisation
     *
     * @param {BootstrapService} bootstrapService Service gérant l'initialisation des variables de l'application viewer cartographique
     *
     */
    constructor(
        private bootstrapService: BootstrapService,
        private _templateInitService: TemplateInitService,
        protected _cd:ChangeDetectorRef,
        ) {
            super(_cd);
        }

    /**
     * @name ngOnInit
     * @description Abonnement à l'observable d'initialisation de l'application et impact ViewModel
     *
     */
    public ngOnInit() {
        this.addSub = this._templateInitService.customerConfig$.subscribe(conf => {
            this.customerConfig = conf;
            this.footer = this.customerConfig.homePage.footer;

            this.markForCheck();
        });

        this.currentStep = this.actions[0];
        this.currentStep.status = 'pending';

        this.addSub = this.bootstrapService.stepsProgress.subscribe(
            step => {
                if (step && step !== undefined) {
                    let currentStep = this.actions.filter(
                        (action) => { return action.id === step.id; }
                    );
                    this.currentStep = currentStep[0];
                    this.currentStep.status = step.status;

                    this.markForCheck();
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/splashscreen/splashscreen.component.ts